export const CREATIVE_IMAGE_TYPE = {
  DEFAULT: 'default',
  LSHAPE: 'l-shape',
  LANDING: 'landing',
} as const;
